import { Box, TextField, Typography } from "@mui/material";
import Theme from "../../../../../utils/Theme";
import { ArrowForward, Done } from "@mui/icons-material";
import { SalesAidsStyles } from "./SalesAidsStyles";

const Appointment = ({ artifacts = {}, setArtifacts, handleArrowClick }) => {
  const handleTextChange = (field, value) => {
    setArtifacts((prev) => ({
      ...prev,
      appointment: {
        ...prev.appointment,
        [field]: value,
        isEdit: true,
      },
    }));
  };

  const handleOptionChange = (field, optionIndex, value) => {
    const updatedOptions = [...(artifacts[field] || [])];
    updatedOptions[optionIndex] = value;

    setArtifacts((prev) => ({
      ...prev,
      appointment: {
        ...prev.appointment,
        [field]: updatedOptions,
        isEdit: true,
      },
    }));
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        bgcolor: artifacts?.isEdit ? "#FFF7F7" : null,
        p: "6px 6px 6px 6px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: 2,
          alignItems: "flex-start",
        }}
      >
        <Box sx={{ flex: 1.05, display: "flex", flexDirection: "column", gap: 2 }}>
          <Typography fontSize={15} fontWeight="bold" color="gray">
            English
          </Typography>
          <TextField
            fullWidth
            variant="outlined"
            label={"Message to be displayed"}
            onChange={(e) => handleTextChange("message", e.target.value)}
            value={artifacts?.message || ""}
            multiline
          />
        </Box>
        <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 2 }}>
          <Typography fontSize={15} fontWeight="bold" color="gray">
            Spanish
          </Typography>
          <TextField
            fullWidth
            variant="outlined"
            label={"Mensaje a mostrar"}
            onChange={(e) => handleTextChange("es_message", e.target.value)}
            value={artifacts?.es_message || ""}
            multiline
          />
        </Box>
        {artifacts?.isEdit ? (
          <Done
            sx={{
              ...SalesAidsStyles.doneIcon,
              color:
                (artifacts?.message &&
                  artifacts?.preference_options?.some((x) => x !== "")) ||
                (artifacts?.es_message &&
                  artifacts?.es_preference_options?.some((x) => x !== ""))
                  ? Theme.palette.primary.main
                  : Theme.palette.action.disabled,
              cursor:
                (artifacts?.message &&
                  artifacts?.preference_options?.some((x) => x !== "")) ||
                (artifacts?.es_message &&
                  artifacts?.es_preference_options?.some((x) => x !== ""))
                  ? "pointer"
                  : "not-allowed",
            }}
            onClick={() => handleArrowClick(artifacts, "appointment")}
          />
        ) : (
          <ArrowForward
            sx={{
              ...SalesAidsStyles.arrowForward,
              color:
                (artifacts?.message &&
                  artifacts?.preference_options?.some((x) => x !== "")) ||
                (artifacts?.es_message &&
                  artifacts?.es_preference_options?.some((x) => x !== ""))
                  ? Theme.palette.primary.main
                  : Theme.palette.action.disabled,
              cursor:
                (artifacts?.message &&
                  artifacts?.preference_options?.some((x) => x !== "")) ||
                (artifacts?.es_message &&
                  artifacts?.es_preference_options?.some((x) => x !== ""))
                  ? "pointer"
                  : "not-allowed",
            }}
            onClick={() => handleArrowClick(artifacts, "appointment")}
          />
        )}
      </Box>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: 2,
          width: "100%",
          height: "100%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            width: "100%",
            height: "100%",
          }}
        >
          {["Drop off box", "Waiting for car", "Drop off and pickup later"].map(
            (label, index) => (
              <TextField
                key={index}
                fullWidth
                variant="outlined"
                label={label}
                value={artifacts?.preference_options?.[index] || ""}
                multiline
                onChange={(e) =>
                  handleOptionChange(
                    "preference_options",
                    index,
                    e.target.value
                  )
                }
              />
            )
          )}
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            width: "100%",
            height: "100%",
          }}
        >
          {[
            "Buzón de entrega",
            "Esperando el coche",
            "Dejar y recoger más tarde",
          ].map((label, index) => (
            <TextField
              key={index}
              fullWidth
              variant="outlined"
              label={label}
              value={artifacts?.es_preference_options?.[index] || ""}
              multiline
              onChange={(e) =>
                handleOptionChange(
                  "es_preference_options",
                  index,
                  e.target.value
                )
              }
            />
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default Appointment;
//  <Box sx={SalesAidsStyles.reviewBox}>
//         <TextField
//           fullWidth
//           variant="outlined"
//           label="Message to be displayed"
//           value={artifacts?.message || ""}
//           multiline
//           onChange={(e) => handleTextChange("message", e.target.value)}
//         />
//         {artifacts?.isEdit ? (
//           <Done
//             sx={{
//               fontSize: 20,
//               color: Theme.palette.primary.main,
//               cursor: "pointer",
//               color:
//                 artifacts?.message &&
//                 artifacts?.preference_options?.some((x) => x !== "")
//                   ? Theme.palette.primary.main
//                   : Theme.palette.action.disabled,
//               cursor:
//                 artifacts?.message &&
//                 artifacts?.preference_options?.some((x) => x !== "")
//                   ? "pointer"
//                   : "not-allowed",
//             }}
//             onClick={() => handleArrowClick(artifacts, "appointment")}
//           />
//         ) : (
//           <ArrowForward
//             sx={{
//               ...SalesAidsStyles.arrowForward,
//               color:
//                 artifacts?.message &&
//                 artifacts?.preference_options?.some((x) => x !== "")
//                   ? Theme.palette.primary.main
//                   : Theme.palette.action.disabled,
//               cursor:
//                 artifacts?.message &&
//                 artifacts?.preference_options?.some((x) => x !== "")
//                   ? "pointer"
//                   : "not-allowed",
//             }}
//             onClick={() => handleArrowClick(artifacts, "appointment")}
//           />
//         )}
//       </Box>
